import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2550bfeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "pw_dialog_title" }
const _hoisted_3 = { class: "password_input_wrap" }
const _hoisted_4 = ["onKeyup"]
const _hoisted_5 = {
  key: 0,
  class: "error_default"
}

import DialogBase from '@/components/molecules/DialogBase'
import PasswordInputFiled from '@/components/molecules/PasswordInputField'
import http from '@/js/utils/http'
import API from '@/js/const/api'
import i18n from '@/plugins/i18n'
import { computed, nextTick, ref, watch, withDefaults } from 'vue'
import { ElMessage } from 'element-plus'

type PropsType = {
  modelValue?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordDialog',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean };

const password1 = ref<string>('')
const password2 = ref<string>('')
const loading = ref<boolean>(false)
const setFocusState = ref<boolean>(false)





const internalValue = computed({
  get: () => props.modelValue,
  set: (newVal) => {
    if (props.modelValue !== newVal) {
      emit('update:modelValue', newVal)
    }
  },
})

const okBtnDisabled = computed<boolean>(() => {
  if (password1.value !== password2.value) {
    return true
  }
  if (password1.value.length < 6 || password2.value.length < 6) {
    return true
  }
  return false
})

const notMatchPasswords = computed<boolean>(() => {
  if (password1.value.length < 6 || password2.value.length < 6) {
    return false
  }
  return password1.value !== password2.value
})

const updatePassword = () => {
  if (
    password1.value !== password2.value ||
    password1.value.length < 6 ||
    password2.value.length < 6
  ) {
    return
  }
  loading.value = true
  http
    .put(API.UPDATE_PASSWORD, { password: password1.value })
    .then(() => {
      loading.value = false
      ElMessage({
        message: i18n.global.t('password_dialog.successful'),
        type: 'success',
      })
      passwordInit()
      emit('close')
    })
    .catch(() => {
      loading.value = false
      ElMessage({
        message: i18n.global.t('password_dialog.failed'),
        type: 'error',
      })
    })
}

const passwordInit = () => {
  password1.value = ''
  password2.value = ''
}

watch(
  () => props.modelValue,
  (v) => {
    if (v) {
      nextTick(() => {
        setFocusState.value = true
      })
    } else {
      setFocusState.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(internalValue),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(internalValue) ? (internalValue).value = $event : null)),
    onApprove: updatePassword,
    onClose: passwordInit,
    "ok-btn-disabled": _unref(okBtnDisabled),
    loading: loading.value
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('password_dialog.change_password')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('password_dialog.please_enter')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            onKeyup: _withKeys(updatePassword, ["enter"])
          }, [
            _createVNode(_unref(PasswordInputFiled), {
              modelValue: password1.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password1).value = $event)),
              type: "password",
              rule: "required|min:6",
              name: "password_input",
              "name-as": _ctx.$t('validation.password'),
              placeholder: _ctx.$t('password_dialog.new_password'),
              klass: "password_dialog_input",
              ref: "password_input",
              setFocusState: setFocusState.value
            }, null, 8, ["modelValue", "name-as", "placeholder", "setFocusState"]),
            _createVNode(_unref(PasswordInputFiled), {
              modelValue: password2.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password2).value = $event)),
              type: "password",
              rule: "required|min:6",
              name: "password_check",
              "name-as": _ctx.$t('validation.password'),
              placeholder: _ctx.$t('password_dialog.confirm_password'),
              klass: "password_dialog_input"
            }, null, 8, ["modelValue", "name-as", "placeholder"]),
            (_unref(notMatchPasswords))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('password_dialog.not_match')), 1))
              : _createCommentVNode("", true)
          ], 40, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "ok-btn-disabled", "loading"]))
}
}

})